var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdgeCut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.904,39.348c-4.081,0-7.503,2.844-8.41,6.652h-7.419c-1.104,0-2,0.896-2,2s0.896,2,2,2h7.419 c0.906,3.808,4.328,6.652,8.41,6.652c4.771,0,8.652-3.882,8.652-8.652C76.557,43.229,72.675,39.348,67.904,39.348z M67.904,52.652 c-2.565,0-4.652-2.087-4.652-4.652s2.087-4.652,4.652-4.652s4.652,2.087,4.652,4.652S70.47,52.652,67.904,52.652z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.923,46h-7.418c-0.906-3.808-4.328-6.652-8.41-6.652c-4.771,0-8.652,3.881-8.652,8.652c0,4.771,3.881,8.652,8.652,8.652 c4.082,0,7.503-2.844,8.41-6.652h7.418c1.104,0,2-0.896,2-2S45.028,46,43.923,46z M28.096,52.652c-2.565,0-4.652-2.087-4.652-4.652 s2.087-4.652,4.652-4.652s4.652,2.087,4.652,4.652S30.661,52.652,28.096,52.652z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeCut);
export default __webpack_public_path__ + "static/media/edge-cut.bd2d98327def21be4bea61122cf9efae.svg";
export { ForwardRef as ReactComponent };